import * as React from 'react';
export var WidgetContext = /*#__PURE__*/React.createContext({
  logger: {},
  httpApi: {},
  buttonProps: undefined,
  open: false,
  companyId: 0,
  phone: '',
  userName: ''
});
export var useWidgetContext = function useWidgetContext() {
  return React.useContext(WidgetContext);
};